var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"invoice-summary-container row mb-4"},_vm._l((_vm.cards),function(card,index){return _c('div',{key:index,staticClass:"col-12 col-sm-6 col-lg-3 mb-3 mb-lg-0"},[_c('invoice-card',{attrs:{"label":card.label,"value":card.value,"sub-value":card.subValue,"icon":card.icon,"color":card.color}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }